import api from "../config/AxiosConfig";
import { setUserLoggerdIn } from "../redux/slices/user-slice";
import { store } from "../redux/store";
import { isNullOrUndefined } from "./CommonFunctions";

export const accessTokenString = "rxpAccessToken";
export const refreshTokenString = "rxpRefreshToken";

export interface TokenUserDTO {
	name: string;
	email: string;
	accessToken: string;
	refreshToken: string;
}

export interface RefreshTokenDTO {
	email: string;
	accessToken: string;
	refreshToken: string;
}

export const removeTokens = () => {
	sessionStorage.removeItem(accessTokenString);
	sessionStorage.removeItem(refreshTokenString);
	localStorage.removeItem(accessTokenString);
	localStorage.removeItem(refreshTokenString);
};

export const setApiAuthHeader = () => {
	let tokenString = sessionStorage.getItem(accessTokenString);
	if (isNullOrUndefined(tokenString)) {
		tokenString = localStorage.getItem(accessTokenString);
	}
	api.setAuthHeader(tokenString);
	store.dispatch(setUserLoggerdIn());
};

export const checkLocalStorageTokens = (): boolean => {
	return (
		(sessionStorage.getItem(accessTokenString) !== null &&
			sessionStorage.getItem(refreshTokenString) !== null) ||
		(localStorage.getItem(accessTokenString) !== null &&
			localStorage.getItem(refreshTokenString) !== null)
	);
};

export const setTokensOnLocalStorage = (
	accessToken: string,
	refreshToken: string,
	rememberMe?: boolean
) => {
	if (isNullOrUndefined(rememberMe)) {
		if (isNullOrUndefined(localStorage.getItem(accessTokenString))) {
			sessionStorage.setItem(accessTokenString, accessToken);
			sessionStorage.setItem(refreshTokenString, refreshToken);
		} else {
			localStorage.setItem(accessTokenString, accessToken);
			localStorage.setItem(refreshTokenString, refreshToken);
		}
	} else if (rememberMe) {
		localStorage.setItem(accessTokenString, accessToken);
		localStorage.setItem(refreshTokenString, refreshToken);
	} else {
		sessionStorage.setItem(accessTokenString, accessToken);
		sessionStorage.setItem(refreshTokenString, refreshToken);
	}
};

export const getRefreshTokenFromStorage = (): string | null => {
	let tokenString = sessionStorage.getItem(refreshTokenString);
	if (isNullOrUndefined(tokenString)) {
		tokenString = localStorage.getItem(refreshTokenString);
	}
	return tokenString;
};
